// Default object
export const defaultTradeTimeConfiguration = {
    trade_time_configuration: {
        status: true,
        corrections: {
            equity: [
                "1815-1915:20231112",
                "0915-1530:20240120",
                "0915-1000,1130-1230:20240302",
                "0915-1000,1130-1230:20240518",
                "1800-1900:20241101",
                "0915-1530:20250201",
                "1345-1445:20251021",
                "0915-1530:20260201"
            ],
            currency: [
                "1815-1915:20231112",
                "0900-1700:20240120",
                "0915-1000,1130-1230:20240302",
                "0915-1000,1130-1230:20240518",
                "1800-1900:20241101",
                "0900-1700:20250201",
                "1345-1445:20251021"
            ],
            commodity: [
                "1815-1915:20231112",
                "0900-2355:20240120",
                "0915-1000,1130-1230:20240302",
                "0915-1000,1130-1230:20240518",
                "1800-1900:20241101",
                "0900-1700:20250101",
                "1700-2355:20250226",
                "1700-2355:20250314",
                "1700-2355:20250331",
                "1700-2355:20250410",
                "1700-2355:20250414",
                "1700-2355:20250501",
                "1700-2355:20250827",
                "1700-2355:20251022",
                "1700-2355:20251105",
                "1345-1445:20251021",
                "1700-2330:20251022",
                "0900-1700:20260101",
                "1700-2355:20260115",
                "0900-1700:20260201",
                "1700-2355:20260303",
                "1700-2355:20260326",
                "1700-2355:20260331",
                "1700-2355:20260414",
                "1700-2355:20260501",
                "1700-2355:20260528",
                "1700-2355:20260626",
                "1700-2355:20260914",
                "1700-2355:20261020",
                "1700-2355:20261110",
                "1700-2355:20261124"
            ]
        },
        trading_time: {
            pre_market_time: "",
            market_time: {
                equity: "0915-1530:23456",
                currency: "0900-1700:23456",
                commodity: "0900-2355:23456"
            },
            post_market_time: ""
        },
        session_holidays: {
            equity: [
                "20240122",
                "20240126",
                "20240308",
                "20240325",
                "20240329",
                "20240411",
                "20240501",
                "20250226",
                "20250314",
                "20250331",
                "20250410",
                "20250414",
                "20250418",
                "20250501",
                "20250815",
                "20250827",
                "20251002",
                "20251022",
                "20251105",
                "20251225",
                "20260115",
                "20260126",
                "20260303",
                "20260326",
                "20260331",
                "20260403",
                "20260414",
                "20260501",
                "20260528",
                "20260626",
                "20260914",
                "20261002",
                "20261020",
                "20261110",
                "20261124",
                "20261225"
            ],
            currency: [
                "20240122",
                "20240126",
                "20240308",
                "20240325",
                "20240329",
                "20240411",
                "20240501",
                "20250219",
                "20250226",
                "20250314",
                "20250331",
                "20250401",
                "20250410",
                "20250414",
                "20250418",
                "20250501",
                "20250512",
                "20250815",
                "20250827",
                "20250905",
                "20251002",
                "20251022",
                "20251105",
                "20251225"
            ],
            commodity: [
                "20240122",
                "20240126",
                "20240308",
                "20240325",
                "20240329",
                "20240411",
                "20240501",
                "20250418",
                "20250815",
                "20251002",
                "20251225",
                "20260126",
                "20260403",
                "20261002",
                "20261225"
            ]
        }
    }
};
